import moment from "moment-timezone";


export const getMonthAndYearOfDate = (date: Date | any) => {
	const  month = moment(date).format('MMMM');
	const year = moment(date).format('YYYY');
	return `${month} ${year}`;
};

export const getMonthAndYearOfDateForAPI = (date: Date | any) => {
	const  month = moment(date).format('MM');
	const year = moment(date).format('YYYY');
	return `${year}-${month}`;
};

export const toISO = (date: Date | string | number) => {
	return new Date(date).toString();
}